import { useState } from "react";
import { useIntl } from "react-intl";

import { useGetBasket, useGetList } from "src/feature/market-place/context/useQuery";

import List from "../component/List";

export default function MarketPlace() {
  useGetList();
  const { refetch } = useGetBasket();

  const intl = useIntl();
  const [search, setSearch] = useState('')

  return (
    <div className="card card-custom card-stretch gutter-b">
      <div className="card-body">
        <div className="card card-custom mb-12">
          <div className="card-body rounded p-0 d-flex " style={{ backgroundColor: '#DAF0FD' }}>
            <div className="d-flex flex-column flex-lg-row-auto w-auto w-lg-350px w-xl-450px w-xxl-500px p-10 p-md-20">
              <h1 className="font-weight-bolder text-dark mb-8">
                {intl.formatMessage({ id: "MARKET.TITLE" })}
              </h1>
              {/* <div className="font-size-h4 mb-8">{intl.formatMessage({ id: "MARKET.DESC" })}</div> */}
              <div className="d-flex flex-center py-2 px-6 bg-white rounded">
                <span className="svg-icon svg-icon-lg svg-icon-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <rect x="0" y="0" width="24" height="24"></rect>
                      <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                      <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fillRule="nonzero"></path>
                    </g>
                  </svg>
                </span>
                <input
                  className="form-control border-0 font-weight-bold pl-2"
                  type="text"
                  placeholder={intl.formatMessage({ id: "GLOBAL.FILTER.SEARCH" })}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div
              className="d-none d-md-flex flex-row-fluid bgi-no-repeat bgi-position-y-center bgi-position-x-right bgi-size-contain"
              style={{ backgroundImage: 'url(https://preview.keenthemes.com/metronic/theme/html/demo1/dist/assets/media/svg/illustrations/progress.svg)' }}
            >
            </div>
          </div>
        </div>

        <List search={search} refetch={refetch} />
      </div>
    </div>
  )
}
